import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import TournamentsPage from "./pages/TournamentsPage";
import BracketPage from "./pages/BracketPage";
import TeamsPage from "./pages/TeamsPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import HallOfFamePage from "./pages/HallOfFamePage";
import RulesPage from "./pages/RulesPage";
import SupportPage from "./pages/SupportPage";
import CodeOfConductPage from "./pages/CodeOfConductPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import PlayOfTheWeekPage from "./pages/PlayOfTheWeekPage";
import BracketGeneratorPage from "./pages/BracketGeneratorPage";
import { AuthProvider, useAuth } from "./lib/auth";

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-400">Loading...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

/**
 * Scroll the window back to the top whenever the route changes. Without
 * this, navigating from a deep page (e.g. a long tournament list) into
 * Leaderboard would land the user mid-page.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tournaments" element={<TournamentsPage />} />
            <Route path="/tournaments/:id" element={<TournamentsPage />} />
            <Route path="/tournament/:id/bracket" element={<BracketPage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/hall-of-fame" element={<HallOfFamePage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/play-of-the-week" element={<PlayOfTheWeekPage />} />
            <Route path="/bracket-generator" element={<BracketGeneratorPage />} />
            <Route path="/code-of-conduct" element={<CodeOfConductPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
